import { BookingInfoSkeleton, HotelDetailsSkeleton, PoliciesSkeleton, SkeletonBlock } from "./HotelTransactionDetailsSkeleton.shared";

export default function HotelTransactionDetailsSkeletonWeb() {
  return (
    <div className="flex w-full gap-2 md:gap-10">
      <div className="flex flex-3 flex-col gap-4">
        <BookingInfoSkeleton />
        <HotelDetailsSkeleton />
        <PoliciesSkeleton />
      </div>
      <div className="flex flex-1 flex-col gap-4">
        <SkeletonBlock className="h-72 w-full rounded-xl" />
        <SkeletonBlock className="h-10 w-full" />
      </div>
    </div>
  );
}
